import {
  ChartingLayerKey,
  ChartingYesNo,
  IChartingPreferencesFormState,
  IChartingSystemPreferences,
  ITreatmentPlanPreferences,
  ToothNumberingSystem,
} from '@dataTypes/chartingPreferences.type'

/** Hide until group-by-tooth display is implemented. */
export const SHOW_GROUP_PROCEDURES_BY_TOOTH_SETTING = false

/** Hide until restore-defaults behavior is finalized. */
export const SHOW_RESTORE_DEFAULTS_BUTTON = false

export const isChartingPreferenceYes = (
  value: ChartingYesNo | undefined,
): boolean => value === 'yes'

export const DEFAULT_CHARTING_SYSTEM: IChartingSystemPreferences = {
  show_tooth_number: 'yes',
  tooth_numbering_system: 'universal_ada',
  show_existing_conditions: 'no',
  show_missing_teeth: 'yes',
  show_primary_teeth: 'yes',
  show_completed_procedures: 'no',
  default_charting_view: ['dental', 'endo'],
  autosave_changes: 'no',
}

export const DEFAULT_TREATMENT_PLAN: ITreatmentPlanPreferences = {
  group_procedures_by_tooth: 'yes',
  auto_mark_completed_when_charted: 'yes',
  allow_manual_fee_override: 'no',
  show_insurance_estimate: 'yes',
}

export const DEFAULT_CHARTING_PREFERENCES_FORM: IChartingPreferencesFormState =
  {
    charting_system: { ...DEFAULT_CHARTING_SYSTEM },
    treatment_plan: { ...DEFAULT_TREATMENT_PLAN },
  }

export const CHARTING_YES_NO_OPTIONS: { value: 'yes' | 'no'; label: string }[] =
  [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
  ]

export const TOOTH_NUMBERING_OPTIONS: {
  value: ToothNumberingSystem
  label: string
}[] = [
  { value: 'universal_ada', label: 'Universal (ADA)' },
  { value: 'fdi', label: 'FDI' },
  { value: 'palmer', label: 'Palmer' },
]

export const DEFAULT_CHARTING_VIEW_OPTIONS: {
  value: ChartingLayerKey
  label: string
}[] = [
  { value: 'dental', label: 'Dental' },
  { value: 'endo', label: 'Endo' },
  { value: 'perio', label: 'Perio' },
]

export const UPPER_ARCH_TOOTH_NUMBERS = Array.from(
  { length: 16 },
  (_, i) => i + 1,
)
